import { render } from "./Tokens.vue?vue&type=template&id=4ea92546&scoped=true"
import script from "./Tokens.vue?vue&type=script&lang=js"
export * from "./Tokens.vue?vue&type=script&lang=js"

import "./Tokens.vue?vue&type=style&index=0&id=4ea92546&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea92546"]])

export default __exports__